// Centralised brand constants
export const LOGO_URL = "/helios_logo_light.png";       // for dark nav / hero
export const LOGO_URL_DARK = "/helios_logo_dark.png";    // for paper/light nav
export const TAGLINE = "Living intelligence for decisions that matter.";

export const MEDIA = {
  hero_bg: "https://static.prod-images.emergentagent.com/jobs/b9bb2eef-fcf6-433f-8696-31a8763bdcc3/images/1e6f75a8324cdb7a19c47d3109e1eb49381359ba2fa42ce355c28d5a32500135.png",
  product_panel: "https://static.prod-images.emergentagent.com/jobs/b9bb2eef-fcf6-433f-8696-31a8763bdcc3/images/af9f4a5bec47f1ebea1a63a59466196993d5d6b57ae8d3e846285fe4d0bbe899.png",
  research_paper: "https://static.prod-images.emergentagent.com/jobs/b9bb2eef-fcf6-433f-8696-31a8763bdcc3/images/c89c059dd6f1fbccb0e1d13d4b1a0b98dcafe53ddaea4f7e0f2670a668a251a8.png",
  use_case_banking: "https://static.prod-images.emergentagent.com/jobs/b9bb2eef-fcf6-433f-8696-31a8763bdcc3/images/45514659a8072b2bb04e5ed55bef84f2731c39d7b8ad80107170245331869294.png",
  use_case_energy: "https://static.prod-images.emergentagent.com/jobs/b9bb2eef-fcf6-433f-8696-31a8763bdcc3/images/665272f4d0cb00cdcd1c14160767379cd15e0a03db9729c5f6cf26ea7cfd5b87.png",
  use_case_public_sector: "https://static.prod-images.emergentagent.com/jobs/b9bb2eef-fcf6-433f-8696-31a8763bdcc3/images/143a521b3f65400333a8b58bed67ae73fafda59c09cf660a1387deca0dd93574.png",
  about_boardroom: "https://static.prod-images.emergentagent.com/jobs/b9bb2eef-fcf6-433f-8696-31a8763bdcc3/images/8a2e4c5a6ddd96ccda5bc22f591a2f33b0cb377611c9953891597cc0a08f189c.png",
};

export const NAV_LINKS = [
  { label: "Product", path: "/product" },
  { label: "Experience", path: "/experience" },
  { label: "Industries", path: "/industries" },
  { label: "Partners", path: "/partners" },
  { label: "Research", path: "/research" },
  { label: "Company", path: "/company" },
];

export const NAV_FOOTER_LINKS = [
  { label: "Europe", path: "/europe" },
  { label: "Trust", path: "/trust" },
];

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
